export default __webpack_public_path__ + "static/media/icon-product-nooio-foodmarket.769ca4ff.svg";